import { render, staticRenderFns } from "./GoalInput.vue?vue&type=template&id=20b06944&scoped=true"
import script from "./GoalInput.vue?vue&type=script&lang=js"
export * from "./GoalInput.vue?vue&type=script&lang=js"
import style0 from "./GoalInput.vue?vue&type=style&index=0&id=20b06944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b06944",
  null
  
)

export default component.exports